/**
 * Filter an array of options to only show the children of a specific parent
 * @param {array} options
 * @param {number} parentName
 */
export const filterOptionsByparentName = (options, parentName) => options.reduce((acc, curr) => {
  if (curr.id === parentName) return acc.concat(curr.child);
  if (curr.child) return acc.concat(filterOptionsByparentName(curr.child, parentName));
  return acc;
}, []);

/**
 * Filter an array of options to only show the children whose name value contains the filter string
 * @param {array} options
 * @param {string} filterString
 * @param {string} filterBy
 * @param {boolean} matchBy
 */
export const filterOptionsByString = (options, filterString, filterBy, matchBy) => {
  if (options.length && filterString) {
    const sanitized = filterString.replace(/[#-.]|[[-^]|[?|{}]/g, '\\$&');
    const startsWith = (filterBy === 'startsWith') ? '^' : '';
    const query = new RegExp(`${startsWith}${sanitized}`, 'i');

    return options.reduce((acc, curr) => {
      if ((filterBy === 'contains') && curr.child) {
        if (filterOptionsByString(curr.child, filterString, filterBy, matchBy).length) {
          return acc.concat(curr);
        }
      }

      const hasMatch = matchBy.some((key) => curr[key] && !!(`${curr[key]}`.match(query)));
      if (hasMatch || (curr.parentName?.match(query))) {
        return acc.concat(curr);
      }
      return acc;
    }, []);
  }
  return options;
};

/**
 * Flatten an array of options for presentation purposes. Used with showGroups prop
 * @param {array} options
 * @param {string} parentName
 */
export const flattenArray = (options, parentName, depth = 1) => options.reduce((acc, curr) => {
  if (curr.child) {
    return acc.concat({
      depth,
      id: curr.id,
      name: curr.name,
      disabled: curr.disabled || false,
      highlight: curr.highlight,
      parentName,
      child: curr.child
    }).concat(flattenArray(curr.child, curr.name, depth + 1));
  }
  return acc.concat({
    id: curr.id,
    name: curr.name,
    disabled: curr.disabled || false,
    highlight: curr.highlight,
    parentName,
    depth
  });
}, []);

/**
 * Combination formater for options
 * @param {array} options
 * @param {string} filterString - string passed to filterOptionsByString
 * @param {number} parentName - id passed to filterOptionsByparentName
 * @param {bool} showGroups - toggle whether to flatten nested options
 */
export const formatOptions = (array, parentName, showGroups) => {
  let formated = array;
  if (showGroups) {
    formated = flattenArray(array);
  }
  if (parentName) {
    formated = filterOptionsByparentName(array, parentName);
  }
  return formated;
};
